import React, { useState } from "react";

type FallbackImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
	alt?: string;
	className?: string;
	// optional classnames to be applied when in fallback
	fallBackClassName?: string;
	// optional fallback image path (we hard-code a default one)
	fallbackSrc?: string;
	src: string;
	style?: string;
	// whether to use a large image placeholder or small (default)
	useLarge?: boolean;
};

const FallbackImage: React.FC<FallbackImageProps> = ({
	fallbackSrc,
	style,
	src,
	alt,
	className,
	fallBackClassName,
	useLarge = false,
	...props
}) => {
	const [imgSrc, setImgSrc] = useState(src);
	const [altSrc, setAltSrc] = useState(alt);
	const [fallbackClass, setFallbackClassName] = useState("");

	const handleError = () => {
		// Prevent infinite loop if fallback also fails
		setOnError(null);

		// Fallback alt text
		setAltSrc(`Image not available ${imgSrc}`);

		// Fallback image path
		const defaultFallback = useLarge
			? "/img/placeholder-lg.jpg"
			: "/img/placeholder-sm.jpg";
		setImgSrc(
			fallbackSrc ? fallbackSrc : process.env.PUBLIC_URL + defaultFallback
		);

		if (fallBackClassName) {
			setFallbackClassName(fallBackClassName);
		}
	};

	const [onError, setOnError] =
		useState<React.ReactEventHandler<HTMLImageElement> | null>(
			() => handleError
		);

	return (
		<img
			src={imgSrc}
			alt={altSrc}
			className={`${className} ${fallbackClass}`}
			onError={onError}
			style={style}
			{...props}
		/>
	);
};

export default FallbackImage;
